import React, { createContext, useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const ReCaptchaContext = createContext();

export const ReCaptchaProvider = ({ children }) => {
  const query = useStaticQuery(graphql`
    {
      allWp {
        nodes {
          allSettings {
            commentsRatingsEnabled
            commentsRatingsRecaptchaEnabled
            commentsRatingsRecaptchaSiteKey
          }
        }
      }
    }
  `);

  const recaptchaKey =
    query.allWp.nodes[0].allSettings.commentsRatingsRecaptchaSiteKey;

  return <ReCaptchaWrapper recaptchaKey={recaptchaKey}>{children}</ReCaptchaWrapper>;
};

const ReCaptchaWrapper = ({ recaptchaKey, children }) =>
  !!recaptchaKey ? (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaKey}
      language="pl"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  ) : (
    children
  );

const useReCaptcha = () => useContext(ReCaptchaContext);

export { useReCaptcha };
export default ReCaptchaProvider;
